
import { Vue, Component, Prop, Model, Watch } from "vue-property-decorator";

import UIButton from "@/components/button/ui-button.vue";
import FormGroup from "@/components/form/FormGroupNew.vue";
import CircleWithInitials from "@/components/card/CircleWithInitials.vue";
import ModalFullScreen from "@/components/modal/ModalFullScreenNew.vue";
import RouteNames from "@/entities/RouteNames";
import CrossIconHover from "@/components/icons/CrossIconHover.vue";
import CrossIcon from "@/components/icons/CrossIconNew.vue";
import PlusIcon from "@/components/icons/ArrowIcon.vue";
import HoveredIcon from "@/components/icons/ArrowIconBlack.vue";
import ProjectHeader from "@/components/projects/ProjectHeader.vue";
import NavGrayArrow from "@/components/icons/NavGrayArrow.vue";
import ProfileGray from "@/components/icons/ProfileGray.vue";
import WarningRed from "@/components/icons/WarningRed.vue";
import ClockIcon from "@/components/icons/ClockGray.vue";
import EditTaskAction from "@/components/projects/activities/EditTaskAction.vue";
import SuitableResources from "@/components/projects/activities/SuitableResourcesV2.vue";
import { hslColorFromName } from "@/utils/hslColorFromName";
import LocationGray from "@/components/icons/LocationGray.vue";
import NotesModal from "@/components/projects/activities/NotesModal.vue";
import ChatIcon from "@/components/icons/MsgIcon.vue";
import { User, Company, Skill } from "@/generated/graphql";

@Component({
  components: {
    PlusIcon,
    HoveredIcon,
    ChatIcon,
    ProjectHeader,
    ProfileGray,
    EditTaskAction,
    ClockIcon,
    LocationGray,
    NavGrayArrow,
    NotesModal,
    UIButton,
    FormGroup,
    SuitableResources,
    CircleWithInitials,
    WarningRed,
    ModalFullScreen,
    CrossIconHover,
    CrossIcon,
  },
})
export default class CalendarEventModal extends Vue {
  @Prop({ type: Array, default: [] }) readonly events!: any[];
  @Prop({ type: Object, required: true }) readonly currentUser!: User;
  @Prop({ type: Object, required: true }) readonly company!: Company;
  isHovered: boolean = false;
  isHoveredChat: boolean = false;
  selectedEvent = null;
  showNotesModal: boolean = false;
  excludeResourceUserId: string = "";  // Added missing property

  contarctorRoute(id) {
    return {
      name: RouteNames.CONTRACTOR_DETAILS_ABOUT,
      params: {
        id: id,
      },
    };
  }

   initial(event, isManager): string {
    const firstName = !isManager ? event.assigneeFirstName : event.managerFirstName;
    const lastName = !isManager ? event.assigneeFamilyName : event.managerFamilyName;

    if (!firstName && !lastName) {
      return "";
    }

    const givenName = firstName ? firstName.trimLeft()[0] : "";
    const familyName = lastName ? lastName.trimLeft()[0] : "";
    return `${givenName}${familyName}`;
  }

requestSkills(event): Skill[] {
    return event.project_activity_skills.map(({ skill }) => skill);
  }

  skillIds(event): number[] {
    return this.requestSkills(event).map(({ id }: Skill) => id);
  }
  handleShow(event) {
    this.selectedEvent = event;
    this.showNotesModal = true;
    // Hide the main modal when notes modal is shown
    document.body.classList.add('notes-modal-open');
  }

  handleClose() {
    this.showNotesModal = false;
    this.selectedEvent = null;
    // Show the main modal again when notes modal is closed
    document.body.classList.remove('notes-modal-open');
  }

 messageManager(event): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: event.managerID,
      },
    });
  }
  bgStyle(event, isManager): any {
    return {
      background: hslColorFromName(this.initial(event, isManager) || ""),
      color: "white",
    };
  }
  message(event): void {
    this.$router.push({
      name: RouteNames.INBOX,
      query: {
        recipientUserId: event.assigneeID,
      },
    });
  }

  visitUpdated(data): void {
    // Emit event to parent to handle activity update
    this.$emit('activityUpdated', data);
  }
  closeModal() {
    // Make sure we clean up any open notes modal
    if (this.showNotesModal) {
      this.showNotesModal = false;
      this.selectedEvent = null;
      document.body.classList.remove('notes-modal-open');
    }
    this.$emit("close");
  }
}
